module.exports = __webpack_public_path__ + "img/6.92a7112f.jpg";